import { SUBSCRIPTION } from "../../Api/constantApi";
import { apiInstance } from "./AxiosApi";

export const subscribe = (payload) => {
    console.log("payload Services", payload)
    return apiInstance.post(SUBSCRIPTION, payload);
};